module.exports = {"name":"Hráči zápasu","icon":"<i class='material-icons'>chrome_reader_mode</i>","widget":[{"type":"match-players","schemas":{"APIpersons":"urn:mbry:schema:1:APIpersons:v1"},"initData":{}}]}


//////////////////
// WEBPACK FOOTER
// ./src/blocks/match-players/match-players.json
// module id = 363
// module chunks = 0